// Recommended

const productRecommendationsSection = document.querySelector('.product-recommendations');
document.addEventListener('DOMContentLoaded', () => {

const url = productRecommendationsSection.dataset.url;

fetch(url)
    .then(response => response.text())
    .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        Array.from(productRecommendationsSection.querySelectorAll("script")).forEach(oldScript => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes)
            .forEach(attr => newScript.setAttribute(attr.name, attr.value));
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript)
        });

        runSplideRecommended();
    })
    .catch(e => {
        console.error(e);
    });
})